export const initialState = {
  isFetching: false,
  orders: [],
}

export const setFetching = (state, payload) => ({
  ...state, isFetching: payload,
})

export const setOrders = (state, payload) => ({
  ...state,
  orders: payload,
  isFetching: false,
})
